import { useQuery } from "@tanstack/react-query";
import { toolboxUpdatesApi } from "@/lib/api/toolbox-updates";

/** TanStack Query keys for the SpecTree Toolbox download (epic PI-SPEC-SW-E288). */
export const toolboxLatestKeys = {
  all: ["toolbox-latest"] as const,
};

/**
 * The newest SpecTree Toolbox release (`GET /toolbox/latest`). The API caches
 * the feed for 5 minutes, so the page keeps its copy as long.
 */
export function useToolboxLatest() {
  return useQuery({
    queryKey: toolboxLatestKeys.all,
    queryFn: () => toolboxUpdatesApi.latest(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
